module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e2382368"
    }
  }, [_c('b', [_vm._v("TURKEY SOUP")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e2382868"
    }
  }, [_c('b', [_c('i', [_vm._v("What’s the Friday after Thanksgiving without turkey soup? Use your favorite vegetables to personalize this simple recipe.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e2384168"
    }
  }, [_c('b', [_vm._v("Prep: 15 minutes plus overnight to chill Cook: 5 hours")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2384968"
    }
  }, [_vm._v("6 carrots, peeled")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2385268"
    }
  }, [_vm._v("3 stalks celery "), _c('br'), _vm._v(" roasted turkey carcass, plus 2 cups cooked turkey meat, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2386168"
    }
  }, [_vm._v("2 medium onions, each cut into quarters")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2386468"
    }
  }, [_vm._v("5 parsley sprigs")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2386868"
    }
  }, [_vm._v("1 garlic clove, peeled")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2387168"
    }
  }, [_vm._v("¼ teaspoon dried thyme")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2388068"
    }
  }, [_vm._v("½ bay leaf")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2389068"
    }
  }, [_vm._v("6 quarts water")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2389368"
    }
  }, [_vm._v("1¼ teaspoons salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2390468"
    }
  }, [_vm._v("1 cup regular long-grain rice, cooked as "), _c('br'), _vm._v(" label directs")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2391168"
    }
  }, [_vm._v("2 tablespoons fresh lemon juice or")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2391468"
    }
  }, [_vm._v("1 tablespoon dry sherry")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e2391968"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Cut 2 carrots and 1 stalk celery into 2-inch pieces. In 12-quart stockpot, combine turkey carcass, carrot and celery pieces, onions, parsley sprigs, garlic, thyme, bay leaf, and 6 quarts water or enough water to cover; heat to boiling over high heat. Skim foam from surface. Reduce heat and simmer, skimming occasionally, 4 hours.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2394668"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Strain broth through colander set over large bowl; discard solids. Strain again through sieve into several containers; cool. Cover and refrigerate overnight.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2396068"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Remove and discard fat from surface of broth; measure broth and pour into 5-quart saucepot. If necessary, boil broth over high heat until reduced to 10 cups to concentrate flavor.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2398268"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" Cut remaining 4 carrots and remaining 2 stalks celery into ½-inch pieces; add to broth with salt. Heat soup to boiling. Reduce heat and simmer until vegetables are tender, about 15 minutes. Stir in cooked rice and turkey; heat through, about 5 minutes. Remove from heat and stir in lemon juice. Makes about 13 cups or 12 first-course servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e2402268"
    }
  }, [_vm._v("Each serving: About 113 calories, 10g protein, 12g carbohydrate, 2g total fat (1g saturated), 21mg cholesterol, 355mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4baa274","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c72_r1.vue
// module id = 282
// module chunks = 0